/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sign_InInputs */

const en_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const de_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const fr_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const es_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const it_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const nl_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen`)
};

const pl_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

const fi_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään`)
};

const da_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind`)
};

const sv_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Nav_Sign_InInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_sign_in = /** @type {((inputs?: Nav_Sign_InInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sign_InInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_sign_in(inputs)
	if (locale === "fr") return fr_nav_sign_in(inputs)
	if (locale === "es") return es_nav_sign_in(inputs)
	if (locale === "it") return it_nav_sign_in(inputs)
	if (locale === "nl") return nl_nav_sign_in(inputs)
	if (locale === "pl") return pl_nav_sign_in(inputs)
	if (locale === "fi") return fi_nav_sign_in(inputs)
	if (locale === "da") return da_nav_sign_in(inputs)
	if (locale === "sv") return sv_nav_sign_in(inputs)
	return en_nav_sign_in(inputs)
});